import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, SimpleChanges } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { DEFAULT_PRECISION } from 'sharedweb/helpers/shared-constants';
import { FormatNumberModule } from 'sharedweb/pipes/format-number/format-number.module';
import { FormatNumberPipe } from 'sharedweb/pipes/format-number/format-number.pipe';
import { Utils } from 'src/app/_helpers';

@Component({
  selector: 'app-custom-card',
  templateUrl: './custom-card.component.html',
  styleUrls: ['./custom-card.component.scss'],
  standalone: true,
  imports: [CommonModule, FormatNumberModule, MatTooltipModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomCardComponent {

  @Input() data: any;
  @Input() direction: 'row' | 'column' = 'row';
  @Input() itemsPerRow: 1 | 2 | 'all' = 'all';
  @Input() isHoldingsPage: boolean = false;
  colorFunction = Utils.getColorClass;
  @Input() coloredColumns: string[] = [];

  chunkedData: any[][] = [];

  defaultPrecision = DEFAULT_PRECISION;

  ngOnInit() { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['itemsPerRow']) {
      this.chunkData();
    }
  }


  chunkData(): void {
    if (this.itemsPerRow === 2) {
      this.chunkedData = [];
      for (let i = 0; i < this.data.length; i += 2) {
        this.chunkedData.push(this.data.slice(i, i + 2));
      }
    } else {
      this.chunkedData = [this.data];
    }
  }
}
